import React, { useContext } from 'react';
import { UserContext } from '../../../Context/UserContextProvider';
import { Link } from 'react-router-dom';

// styles
import styles from "./SeeBlogs.module.css"

//Images
import calenderIcon from "../../../../assets/img/HomePage/BlogCalenderIcon.svg"
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowLeftBlue.svg"

const BlogsCard = (props) => {
    const { permissions } = useContext(UserContext);
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    return (
        <>
            <div className={`w-100 d-flex align-items-center justify-content-xl-between justify-content-center flex-wrap ${styles.cards_container}`}>
                {props.blogsData == "" ?
                    <div className={`w-100 d-flex align-items-center justify-content-center ${styles.card_title}`}>
                        آیتم مورد نظر یافته نشد
                    </div>
                    :
                    props.blogsData?.map((item) => (
                        <div key={item.id} className={`d-flex align-items-center flex-column px-2 py-3 mt-3 mb-4 mx-md-3 mx-0 ${styles.blog_card_container}`}>
                            <div className='w-100 position-relative mb-3'>
                                <Link to={{
                                    pathname: `/blog-dashboard-detail/${item.id}`,
                                    state: item
                                }}>
                                    <img className={styles.card_img} src={`https://backdev.azrmelk.com/magAssets/img/Articles/${item.imageName}`} alt="card-img" />
                                </Link>
                            </div>
                            <div className="w-100 d-flex justify-content-start px-2 mb-2">
                                <Link className={styles.card_title} to={{
                                    pathname: `/blog-dashboard-detail/${item.id}`,
                                    state: item
                                }}>{item.title}</Link>
                            </div>
                            <div className="w-100 d-flex justify-content-start px-2 my-2">
                                <img className='ms-2' src={calenderIcon} alt="icon" />
                                <div className={styles.title2}>
                                    {e2p(item.dateRelease?.toString())}
                                </div>
                            </div>
                            {permissions?.find((item) => item === 13) === 13 &&
                                <Link to={{
                                    pathname: `/edit-blog/${item.id}`,
                                    state: item
                                }} className="w-100 d-flex justify-content-end px-2 my-2">
                                    <div className={styles.text_primary}>
                                        ویرایش
                                    </div>
                                    <img className='me-2' src={arrowIcon} alt="icon" />
                                </Link>
                            }

                        </div>
                    ))
                }
            </div>
        </>
    );
};

export default BlogsCard;